/**
 * LegalPlaceholder — tela placeholder para documentos legais (GUPM-212).
 *
 * Termos de Uso e Política de Privacidade ainda não foram redigidos. As rotas
 * (`/termos`, `/privacidade`) existem para uso futuro; hoje os itens do menu de
 * usuário que apontam pra cá ficam desabilitados. Quando o texto existir, basta
 * trocar este placeholder pelo conteúdo real e habilitar os itens do menu.
 */
import { PageHeader } from '@/ui';

interface LegalPlaceholderProps {
  titulo: string;
}

export default function LegalPlaceholder({ titulo }: LegalPlaceholderProps) {
  return (
    <div>
      <PageHeader title={titulo} />
      <div className="max-w-2xl rounded-xl border border-jf-border bg-jf-surface2 p-6 text-center">
        <div className="mb-2 text-3xl" aria-hidden>🔒</div>
        <p className="text-sm font-semibold text-white">Documento em elaboração</p>
        <p className="mt-1 text-[13px] text-jf-muted">
          O conteúdo de <strong>{titulo}</strong> ainda será publicado. Assim que
          disponível, ficará acessível por aqui.
        </p>
      </div>
    </div>
  );
}
